import React from 'react';
import { func, string, bool } from 'prop-types';
import Tooltip from '@Components/Tooltip';
import './styles.scss';

const Actions = ({
  onDownload,
  icon = 'bi bi-arrow-down-circle-fill',
  disabled = false,
  hidden = false,
  tooltipText = 'Descargar',
  tooltipPlacement = 'top'
}) => {
  if (hidden) return null;

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onDownload(e);
    }
  };

  const iconElement = (
    <i
      className={icon}
      onClick={disabled ? undefined : onDownload}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={disabled ? -1 : 0}
    />
  );

  return (
    <>
      {disabled ? (
        <span className="grid-actions-disabled disabled-action">
          <Tooltip text={tooltipText} disabled={disabled}>
            {iconElement}
          </Tooltip>
        </span>
      ) : (
        <div className="grid-actions-wrapper actions-wrapper">
          <Tooltip
            text={tooltipText}
            placement={tooltipPlacement}
            disabled={disabled}
          >
            {iconElement}
          </Tooltip>
        </div>
      )}
    </>
  );
};

Actions.propTypes = {
  onDownload: func.isRequired,
  icon: string,
  disabled: bool,
  hidden: bool,
  tooltipText: string,
  tooltipPlacement: string
};



export default Actions;
